import * as actionTypes from './actionTypes';
import axios from "axios";
import api from '../../utilities/api';
import { getMessage } from '../../utilities/getMessage';

export const get23Limits=(token)=>async dispatch=>{
    dispatch({
        type:actionTypes.GET_23LIMITS_START
    })
    const options={
        url:`${api}/twoThreeLimitations`,
        method:'GET',
        headers:{
            'Authorization':`Bearer ${token}`
        },
        data:{}
    }
    await axios(options)
            .then(response=>dispatch({
                type:actionTypes.GET_23LIMITS_SUCCESS,
                payload:response.data
            }))
            .catch(error=>dispatch({
                type:actionTypes.GET_23LIMITS_FAIL,
                payload:getMessage(error)
            }))
}